import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css }: any) => ({
  root: css``,
}));

export const useButtonAddCartStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
